import { useEffect, useState } from "react";
import GetAuthContext from "../context/AuthContext";
import { Get } from "../services/Fetch";

export type reload = () => Promise<any> | "";

export type UseFetchReturnType<T> = {
  data: T | null;
  status: boolean;
  error: string;
  isLoading: boolean;
  reload?: reload;
};

const useFetch = <T>(
  path: string,
  additionalHeaders?: Headers
): UseFetchReturnType<T> => {
  const [isLoading, setIsLoading] = useState(true);
  const [state, setState] = useState<{
    data: null | T;
    error: string;
    status: boolean;
  }>({
    data: null,
    error: "",
    status: false,
  });

  const { fetchToken } = GetAuthContext();

  const fetcher = async () => {
    setIsLoading(true);
    const json = await Get<T>(path, fetchToken(), additionalHeaders);
    setState({
      data: json.status ? json.data : null,
      status: json.status,
      error: json.error,
    });
    setIsLoading(false);
    return json;
  };

  useEffect(() => {
    fetcher();
  }, [path]);

  return {
    data: state.data,
    status: state.status,
    error: state.error,
    isLoading,
    reload: fetcher,
  };
};

export default useFetch;
